import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import { KalDate } from '@kalidea/kaligraphi';
import { environment } from 'src/environments/environment';

@Directive({
    selector: '[appDisplayDatePeriod]',
    standalone: false
})
export class DisplayDatePeriodDirective implements OnChanges {

    constructor(private element: ElementRef) {
    }

    private _startDate: string;

    @Input()
    set startDate(date: string | KalDate) {
        this._startDate = date ? new KalDate(date, environment.date.format.isoQuery).toString() : null;
    }

    private _endDate: string;

    @Input()
    set endDate(date: string | KalDate) {
        this._endDate = date ? new KalDate(date, environment.date.format.isoQuery).toString() : null;
    }

    private getText(): string {
        if (this._startDate && this._endDate) {
            return `du ${this._startDate} au ${this._endDate}`;
        } else if (this._startDate && !this._endDate) {
            return `à partir du ${this._startDate}`;
        } else if (!this._startDate && this._endDate) {
            return `jusqu'au ${this._endDate}`;
        } else {
            return '';
        }
    }

    ngOnChanges(): void {
        this.element.nativeElement.innerHTML = this.getText();
    }

}
